import { ElementState } from "@creatomate/preview";
import { ElementSource } from "chq";

const moveOverlappedElement = (
  allJsonElements: ElementSource[],
  element: ElementState,
  placement: { time: number; duration: number },
  overlappingElements: ElementState[],
  elements?: ElementState[]
) => {
  let updatedElements: ElementSource[] = [];
  let newPlacement = { ...placement };

  // element is overlapping others
  const sortedElements = elements?.slice();
  let currentElementIndex = sortedElements?.findIndex(
    elm => elm.source.id === element.source.id);

  if (currentElementIndex !== undefined && sortedElements) {
    sortedElements[currentElementIndex] = {
      ...sortedElements[currentElementIndex],
      globalTime: placement.time
    };
    sortedElements.sort((a, b) => a.globalTime - b.globalTime);
    currentElementIndex = sortedElements?.findIndex(elm => elm.source.id === element.source.id);
    const draggingRight = element.globalTime < placement.time;
    const controlElement = overlappingElements[
      draggingRight ? overlappingElements.length - 1 : 0
    ];
    const moveToRight = controlElement.globalTime < placement.time;
    let newTime = moveToRight
      ? controlElement.globalTime + controlElement.duration
      : controlElement.globalTime - element.duration;
    if (moveToRight) {
      // has to be positioned to the right
      newTime = controlElement.globalTime + controlElement.duration;
    } else if (currentElementIndex >= 1) {
      // it has other elements to the left
      const previousElement = sortedElements[currentElementIndex - 1];
      const isOverlappingPrev = newTime < previousElement.globalTime + previousElement.duration;
      if (isOverlappingPrev) newTime = previousElement.globalTime + previousElement.duration;
    } else {
      // it has no other elements to the left
      newTime = Math.max(newTime, 0);
    }

    // position the dragged elememt
    newPlacement = { time: newTime, duration: element.duration };
    updatedElements = allJsonElements.map((currentElement: ElementSource) => {
      if (currentElement.id !== element.source.id) return currentElement;
      return {
        ...currentElement,
        time: newTime
      };
    });

    sortedElements[currentElementIndex] = {
      ...sortedElements[currentElementIndex],
      globalTime: newTime
    };

    // position the rest of the elements
    let amountToMove = 0;
    for (let i = 0; i < sortedElements.length - 1; i += 1) {
      const leftElement = sortedElements[i];
      const rightElement = sortedElements[i + 1];
      const leftElementEndTime = leftElement.globalTime + leftElement.duration;
      const leftOverlaps = leftElementEndTime > rightElement.globalTime;
      if (leftOverlaps) {
        if (amountToMove === 0) amountToMove = leftElementEndTime - rightElement.globalTime;
      }

      const newElementTime = rightElement.globalTime + amountToMove;

      updatedElements = updatedElements.map((currentElement: ElementSource) => {
        if (currentElement.id !== rightElement.source.id) return currentElement;
        return {
          ...currentElement,
          time: newElementTime
        };
      });
      sortedElements[i + 1] = {
        ...sortedElements[i + 1],
        globalTime: newElementTime
      };
    }
  }
  return { updatedElements, newPlacement };
};

export default moveOverlappedElement;
